import DigitBall from '@/common-pages/mix-lottery/component/digit-ball';
import Tag from '@/common-pages/mix-lottery/component/tag';
import {
  COLORS,
  MAIN_KEY,
  RESULT_INDEX,
} from '@/common-pages/mix-lottery/constant';
import FeeDetail from '@/common-pages/mix-lottery/lottery-order/fee-detail';
import {
  LotteryOrderTicket,
  checkType,
} from '@/common-pages/mix-lottery/mix-lottery-service';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import OrderListItemStatus from '@/components/business/order/order-list-item-status';
import Price from '@/components/business/price';
import theme from '@/style';
import React from 'react';
import {View, StyleSheet} from 'react-native';

const DEFAULT = ['A', 'B', 'C', 'D'];
const SIDE_TYPE = ['Odd', 'Even', 'Big', 'Small'];
const F_P_C_TYPE = ['Fish', 'Prawn', 'Crab'];

const ListItem = ({
  index = 0,
  modeID = 1,
  amount,
  fee,
  betNo,
  ticketStatus,
  prize,
  odds,
  tabName,
  modeName,
  betItem,
  isOpen,
  isQuick,
}: LotteryOrderTicket & {
  index: number;
  isOpen?: boolean;
  isQuick?: boolean;
}) => {
  const [showMore, setShowMore] = React.useState(false);
  // const {i18n} = useTranslation();

  const backgroundColor = React.useMemo(() => {
    return {
      backgroundColor: index % 2 === 1 ? '#3B3F49' : '#31343D',
    };
  }, [index]);

  const tagInfo = React.useMemo(() => {
    if (modeID === 1) {
      if (betItem) {
        const TYPE_INDEX = (betItem - 1) % 4;
        const INDEX = Math.trunc((betItem - 1) / 4);
        return {
          type: DEFAULT[INDEX],
          label: SIDE_TYPE[TYPE_INDEX],
        };
      }
    }
    if (modeID === 9) {
      const TYPE_INDEX = (betItem - 1) % 3;
      return {
        type: 'D',
        label: F_P_C_TYPE[TYPE_INDEX],
      };
    }
    return {};
  }, [modeID, betItem]);

  const numbers = React.useMemo(() => {
    if (tagInfo.label) {
      if (modeID === 1) {
        return `${tagInfo.type}-${tagInfo.label}: ${MAIN_KEY[tagInfo.label]}`;
      }
      if (modeID === 9) {
        return `${tagInfo.label}: ${MAIN_KEY[tagInfo.label]}`;
      }
    }
    return '';
  }, [modeID, tagInfo]);

  const betInfo = React.useMemo(() => {
    if (checkType(modeID).isx4) {
      const indexs = RESULT_INDEX.slice(-4);
      return betNo
        .slice(-4)
        .split('')
        .map((item, _i) => {
          return {
            number: item,
            bg: COLORS[indexs[_i]],
          };
        });
    }
    if (checkType(modeID).isx3) {
      const indexs = RESULT_INDEX.slice(-3);
      return betNo
        .slice(-3)
        .split('')
        .map((item, _i) => {
          return {
            number: item,
            bg: COLORS[indexs[_i]],
          };
        });
    }
    if (checkType(modeID).isx2) {
      const indexs = RESULT_INDEX.slice(-2);
      return betNo
        .slice(-2)
        .split('')
        .map((item, _i) => {
          return {
            number: item,
            bg: COLORS[indexs[_i]],
          };
        });
    }
    if (checkType(modeID).isx1) {
      return betNo
        .slice(-1)
        .split('')
        .map((item, _i) => {
          return {
            number: item,
            bg: theme.basicColor.primary,
          };
        });
    }
    return [];
  }, [modeID, betNo]);

  const status = React.useMemo(() => {
    if (isOpen) {
      if (prize > 0) {
        return 1;
      }
      if (isQuick) {
        return 0;
      } else {
        return ticketStatus === 0 ? 3 : 0;
      }
    }
    return 2;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, ticketStatus, prize]);

  return (
    <View style={[backgroundColor]}>
      <NativeTouchableOpacity
        onPress={() => setShowMore(!showMore)}
        style={[
          theme.flex.row,
          theme.flex.between,
          theme.padding.l,
          theme.flex.centerByCol,
          {gap: theme.paddingSize.s},
        ]}>
        {modeID === 9 || modeID === 1 ? (
          <View
            style={[
              theme.flex.row,
              {gap: theme.paddingSize.xxs},
              styles.number,
            ]}>
            {tagInfo.type && (
              <Tag
                label={tagInfo.label}
                backgroundColor={COLORS[tagInfo.type]}
              />
            )}
          </View>
        ) : (
          <View
            style={[
              theme.flex.row,
              {gap: theme.paddingSize.xxs},
              styles.number,
            ]}>
            {betInfo.map((item, i) => (
              <DigitBall
                isPrimary={checkType(modeID).isX}
                key={i}
                digit={item.number}
                bg={item.bg}
                type={'A'}
              />
            ))}
          </View>
        )}
        <View style={styles.time}>
          <Price
            price={amount + fee}
            textProps={{size: 'medium', textAlign: 'center'}}
          />
        </View>
        <View
          style={[
            theme.flex.row,
            theme.flex.centerByCol,
            theme.flex.end,
            theme.flex.flex1,
          ]}>
          <OrderListItemStatus
            hasDetail
            showMore={showMore}
            status={status}
            awardAmount={prize}
          />
        </View>
      </NativeTouchableOpacity>
      {showMore && (
        <FeeDetail
          fee={fee}
          delivery={amount}
          odds={odds}
          numberType={tagInfo.type}
          numbers={numbers}
          type={`${modeName}-${tabName}`}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  itemAction: {
    height: 48,
  },
  iconSize: {
    width: 14,
    height: 14,
  },
  ballSize: {
    width: 28,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
  },
  number: {
    flex: 1,
  },
  time: {
    flex: 1,
    alignItems: 'center',
  },
});

export default ListItem;
